import { HistoryViewModel } from '../support/HistoryViewModel';
import { AgencyBeaState } from './AgencyBeaState';

// Agency Bea links a client as innerhive://client/<id>, the id the api addresses the client by: its
// care map id, with the owner appended only where two clients of one organization share one.
const CLIENT_LINK_PREFIX = 'innerhive://client/';

/** Turns the client links in Bea's answers into navigation to the client's care map. */
export class ClientLinkNavigator {
    static inject = () => [HistoryViewModel, AgencyBeaState];
    constructor(private history: HistoryViewModel, private agencyBea: AgencyBeaState) {}

    isClientLink = (href: string): boolean => href.startsWith(CLIENT_LINK_PREFIX);

    /** The care map id a client link names, or undefined for any other link. */
    careMapIdOf = (href: string): string | undefined => {
        if (!this.isClientLink(href)) {
            return undefined;
        }
        const id = href.slice(CLIENT_LINK_PREFIX.length);
        return id ? id.split('-')[0] : undefined;
    };

    open = (careMapId: string) => {
        this.history.push(`/care/${careMapId}`);
        this.agencyBea.clientLinkFollowed();
    };
}
